export default __webpack_public_path__ + "static/media/icons_services.1c0cd325.svg";